import React, { useCallback, useState } from 'react';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import { DatePicker, MobileDatePicker } from '@mui/x-date-pickers';
import moment from 'moment/moment';
import CurrencyList from 'components/CurrencyList/CurrencyList';
import { VALUATION_MARKET_DATE_TEST_IDS } from 'pages/ValuationsAllocation/ValuationMarketDate.testIds';
import MarketDateDialogProps from './MarketDateDialog.props';
import { FormDialog } from '../../../../components';
import { StyledMobileDatePicker } from '../../../../components/DatePickers';
import { MOMENT_DEFAULT_DATE_FORMAT } from '../../../../utilities';

const MarketDateDialog = ({ onSave, open, onClose, marketDate, marketCurrency }: MarketDateDialogProps) => {
  const [formMarketDate, setFormMarketDate] = useState<string>(marketDate);
  const [formMarketCurrency, setFormMarketCurrency] = useState<string>(marketCurrency);

  const handleSave = useCallback(() => {
    onSave({
      marketDate: formMarketDate,
      marketCurrency: formMarketCurrency,
    });
    onClose();
  }, [formMarketDate, formMarketCurrency, onSave, onClose]);

  const onCurrencyChange = useCallback((event: React.ChangeEvent<unknown>, option: { value: string }) => {
    setFormMarketCurrency(option.value);
  }, []);

  return (
    <FormDialog
      open={open}
      onClose={onClose}
      onSave={handleSave}
      isValid={!!formMarketDate}
      PaperProps={{ 'data-testid': VALUATION_MARKET_DATE_TEST_IDS.dialog }}
      title="Select Market Date">
      <>
        <StyledMobileDatePicker
          maxDate={moment().subtract(1, 'days').toDate() ? new Date(moment().subtract(1, 'days').toDate()) : undefined}
          label="Market Date"
          onChange={newDate => setFormMarketDate(moment(newDate).format(MOMENT_DEFAULT_DATE_FORMAT))}
          format="MM/dd/yyyy"
          value={formMarketDate ? new Date(formMarketDate) : null}
          slotProps={{
            textField: {
              placeholder: 'SELECT DATE',
              inputProps: {
                'data-testid': VALUATION_MARKET_DATE_TEST_IDS.dateInput,
              },
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    <CalendarIcon />
                  </InputAdornment>
                ),
              },
            },
          }}
        />
        <br />
        <br />
        <CurrencyList
          label="Market Currency"
          formCurrency={formMarketCurrency}
          handleCurrencyChange={onCurrencyChange}
        />
      </>
    </FormDialog>
  );
};

export default MarketDateDialog;
